export default __webpack_public_path__ + "static/media/flag.1b3cea31.svg";